import { FilterChipBar } from "./FilterChipBar";
import { listCrewFunctions, type CrewWithFunction } from "@/lib/crewFunctionFilter";

type FunctionFilterBarProps = {
  // Crew currently in scope. Functions are deduped and sorted internally,
  // so callers can pass the raw crew list.
  crew: CrewWithFunction[];
  selected: ReadonlySet<string>;
  onToggle: (fn: string) => void;
  onClear: () => void;
  // Omitted by the creator's crew list, whose card heading already says
  // what the list is.
  title?: string;
};

/**
 * "Filter by function" chips, used by the read-only producer timeline and
 * the schedule creator's crew list so both screens filter identically.
 */
export function FunctionFilterBar({ crew, ...rest }: FunctionFilterBarProps) {
  return (
    <FilterChipBar options={listCrewFunctions(crew)} testIdPrefix="function-filter" {...rest} />
  );
}
